import { Component, inject, input, OnInit, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SubmitButtonComponent } from '@infodocs/shared/components/submit-button/submit-button.component';
import { companyNameValidator, strictCipcNameValidator } from '@infodocs/shared/forms/validators/custom-validators';
import { ShouldShowErrorPipe } from '@infodocs/shared/pipes/should-show-error.pipe';

export type ProposedNamesResult = {
	name_1: string;
	name_2: string;
	name_3: string;
	name_4: string;
};

@Component({
	selector: 'app-proposed-names-form',
	templateUrl: './proposed-names-form.component.html',
	imports: [ReactiveFormsModule, SubmitButtonComponent, ShouldShowErrorPipe],
})
export class ProposedNamesFormComponent implements OnInit {
	public readonly initialNames = input<Partial<ProposedNamesResult>>();
	public readonly confirmed = output<ProposedNamesResult>();
	public readonly cancelled = output<void>();

	private readonly fb = inject(FormBuilder);

	protected readonly proposedNamesForm = this.fb.group({
		name_1: ['', [Validators.required, companyNameValidator(), strictCipcNameValidator()]],
		name_2: ['', [companyNameValidator(), strictCipcNameValidator()]],
		name_3: ['', [companyNameValidator(), strictCipcNameValidator()]],
		name_4: ['', [companyNameValidator(), strictCipcNameValidator()]],
	});

	public ngOnInit(): void {
		const names = this.initialNames();
		if (names) {
			this.proposedNamesForm.patchValue(names);
		}
	}

	protected close(): void {
		this.cancelled.emit();
	}

	protected confirm(): void {
		if (!this.proposedNamesForm.valid) {
			this.proposedNamesForm.markAllAsTouched();
			return;
		}

		const value = this.proposedNamesForm.getRawValue();
		this.confirmed.emit({
			name_1: value.name_1 ?? '',
			name_2: value.name_2 ?? '',
			name_3: value.name_3 ?? '',
			name_4: value.name_4 ?? '',
		});
	}
}
